import { LoadingLayer } from '../../LoadingLayer';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
//import { saveAbstractRequest } from '../registered-abstracts/RegisteredAbstracts';
import { SideMenuAdmin } from './SideMenuAdmin';

export const fetchAbstracts = async (setAbstracts) => {
  try {
    const response = await fetch(
      'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/abstracts/esd',
      {
        headers: {
          'user-token': localStorage.getItem('id_token'),
        },
      },
    );
    const data = await response.json();
    console.log(data);
    setAbstracts(data.Items);
  } catch (error) {
    console.error('Error:', error);
    return error;
  }
};


export const AdminAbstract = () => {
  const [abstracts, setAbstracts] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [selectedRevisors, setSelectedRevisors] = useState({});
  const revisors_emails = [
      "pesitrama_80@yahoo.com",
      "raul.lucioprt@uanl.edu.mx",
      "dpacheco.catalan@gmail.com",
      "gramos@xanum.uam.mx",
      "jgvazquez@ipn.mx",
      "ivalemus@gmail.com",
      "akcg@ens.cnyn.unam.mx",
      "kriegeradler@hotmail.com"
  ]

  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading');
    fetchAbstracts(setAbstracts).then(() => {
      setIsLoading(false);
    });
  }, []);

  // const deleteAbstract = (abstractId, updates_at) => {
  //   console.log('Deleting');
  //   setIsLoading(true);
  //   setLoadingMessage('Deleting abstracts');
  //   saveAbstractRequest({ abstract_id: abstractId, updated_at: updates_at }).then(() =>
  //     window.location.reload(),
  //   );
  // };

  const handleRevisorChange = (abstractId, email) => {
    setSelectedRevisors((prev) => ({ ...prev, [abstractId]: email }));
  };

  const updateRevisor = async (abstractId, updated_at) => {
    const email = selectedRevisors[abstractId];
    if (!email) return;
    setIsLoading(true);
    setLoadingMessage('Actualizando revisor...');
    try {
      await fetch('https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/revisor-assign', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'user-token': localStorage.getItem('id_token'),
        },
        body: JSON.stringify({
          abstract_id: abstractId,
          updated_at: updated_at,
          revisor: email,
        }),
      });
      setIsLoading(false);
      setLoadingMessage('');
      // Opcional: recargar abstracts o mostrar confirmación
      fetchAbstracts(setAbstracts);
    } catch (error) {
      setIsLoading(false);
      setLoadingMessage('');
      alert('Error al actualizar revisor');
    }
  };

    const SendCertificate = async (abstractId, updated_at) => {
        console.log(abstractId);
        console.log("Enviando carta ...");
        setIsLoading(true);
        setLoadingMessage('Enviando carta...');
        try {
            await fetch('https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/abstracts/certificate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'user-token': localStorage.getItem('id_token'),
                },
                body: JSON.stringify({
                    abstract_id: abstractId,
                    updated_at: updated_at,
                    participation: true,
                }),
            });
            setIsLoading(false);
            setLoadingMessage('');
            // Opcional: recargar abstracts o mostrar confirmación
            fetchAbstracts(setAbstracts);
            console.log("Carta enviada");

        } catch (error) {
            setIsLoading(false);
            setLoadingMessage('');
            console.log('Error al actualizar revisor');
        }
    };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuAdmin />
      <div className="snn-abstract-submission-main-grid-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />

        <section className="snn-expand-grid-4">
          <h1 className="snn-user-home-main-content-header">Abstracts</h1>
          <div>
            {abstracts &&
              abstracts.map((abstract) => (
                 <div key={abstract.id + abstract.title}>
                  <div
                    className='snn-abstract-registered-card snn-user-home-abstract-bio'>
                    <p className="snn-user-home-main-content-small-text">{abstract.status}</p>
                    {abstract.code === 'undefined' ? null : (
                      <p className="snn-user-home-main-content-small-text">{abstract.code}</p>
                    )}
                    <div className="snn-abstract-registered-card-text">
                      <div className="snn-abstract-admin-details">
                        <p className="snn-user-home-main-content-large-semi">{abstract.title}</p>
                        <p>
                          Authors: <strong>{Array.isArray(abstract.authors)
    ? abstract.authors.map((author, idx, arr) => {
        // Obtener todas las afiliaciones únicas
        const affiliations = Array.from(new Set(arr.map(a => a.affiliations).flat()));
        // Construir los índices de afiliación para este autor
        const affIndexes = (author.affiliations || []).map(aff => affiliations.indexOf(aff) + 1).join(', ');
        return (
          <span key={author.name + idx}>
            {author.lastName} {author.name && author.name.length > 0 ? author.name[0] + '.' : ''}
            {affIndexes && <sup>{affIndexes}</sup>}
            {idx < arr.length - 1 ? ', ' : ''}
          </span>
        );
      })
    : abstract.authors}
  </strong>
                        </p>
                        <p>
                          Affiliations: <strong>{Array.isArray(abstract.authors) ? Array.from(new Set(abstract.authors.map(a => a.affiliations).flat())).map((aff, idx) => (<span key={aff}><sup>{idx+1}</sup> {aff}{idx < Array.from(new Set(abstract.authors.map(a => a.affiliations).flat())).length-1 ? <br/> : null}</span>)) : ''}</strong>
                        </p>
                        <p>
                          User email: <strong>{abstract.user_email}</strong>
                        </p>
                        <p>
                          Updated at: <strong>{abstract.updated_at}</strong>
                        </p>
                        <p>
                          Revisor: <strong>{abstract.revisor ? abstract.revisor:"Not revisor selected"}</strong>
                        </p>
                          {
                              abstract.participation ?
                                  <>
                                      <p>
                                          <strong>¡Certificado enviado!</strong>
                                      </p>
                                  </>
                                  : null
                          }
                        <div style={{ marginTop: '10px' }}>
                          <select
                              value={selectedRevisors[abstract.id] || ''}
                              onChange={e => handleRevisorChange(abstract.id, e.target.value)}
                          >
                            <option value='' disabled>Selecciona revisor</option>
                            {revisors_emails.map(email => (
                                <option key={email} value={email}>{email}</option>
                            ))}
                          </select>
                          <button
                              style={{ marginLeft: '8px' }}
                              onClick={e => {
                                e.preventDefault();
                                updateRevisor(abstract.id, abstract.updated_at);
                              }}
                              disabled={!selectedRevisors[abstract.id]}
                          >
                            Actualizar revisor
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="snn-abstract-registered-card-buttons-wrapper">
                        <div onClick={() => SendCertificate(abstract.id, abstract.updated_at)} className="snn-abstract-registered-card-button">
                            Add certificate <span className="material-symbols-outlined">order_approve</span>
                        </div>
                        <Link to={`/abstracts/${abstract.id}`}>
                        <div className="snn-abstract-registered-card-button">
                          View <span className="material-symbols-outlined">find_in_page</span>
                        </div>
                      </Link>
                    </div>
                  </div>
                 </div>
              ))}
          </div>
        </section>
      </div>
    </div>
  );
};
